webpackJsonp([131627143932366],{

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image1.08a1b975.jpg";

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image10.386f4d25.jpg";

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image11.b0d57148.jpg";

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image12.0ac641ab.jpg";

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image2.f0c55a6a.jpg";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image3.13b03cc1.jpg";

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image4.da66be46.jpg";

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImageGallery = __webpack_require__(27);
	
	var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
	
	__webpack_require__(25);
	
	var _image = __webpack_require__(126);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _image3 = __webpack_require__(130);
	
	var _image4 = _interopRequireDefault(_image3);
	
	var _image5 = __webpack_require__(131);
	
	var _image6 = _interopRequireDefault(_image5);
	
	var _image7 = __webpack_require__(132);
	
	var _image8 = _interopRequireDefault(_image7);
	
	var _image9 = __webpack_require__(129);
	
	var _image10 = _interopRequireDefault(_image9);
	
	var _image11 = __webpack_require__(127);
	
	var _image12 = _interopRequireDefault(_image11);
	
	var _image13 = __webpack_require__(128);
	
	var _image14 = _interopRequireDefault(_image13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AgeFriendlyCommunitiesPage = function AgeFriendlyCommunitiesPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 project-info' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Age Friendly Communities'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'By 2021 it is estimated that more than 25% of Victoria\u2019s population will be over 60. In some regional areas it is estimated to reach almost 50%.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Council on the Ageing (COTA) Victoria and two Melbourne artists are facing these developments with the creative approach of storytelling, one of the oldest art forms and ways of sharing experience. Throughout history older people have been humanity\u2019s consummate storytellers. COTA Victoria, the peak body for older people in Victoria, provides a platform for them to tell their unique stories, to participate and belong to a community that strives to be respectful and age-friendly. But what does being age-friendly even mean? By listening to stories of older people we will find out what they understand of an age-friendly world.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'As Event Coordinator and Research Volunteer, I am responsible for organising COTA\u2019s first interactive art exhibition about growing older in the community and the meaning of age-friendliness. Participative observations and narrative analysis will help to understand what the concept of age-friendliness for senior\u2019s means as well as how and where age-friendly interventions can happen.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A further analysis of the story material will be indicated on the COTA Victoria Website.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'slider' },
	                    _react2.default.createElement(_reactImageGallery2.default, {
	                        showThumbnails: false,
	                        showFullscreenButton: false,
	                        autoPlay: true,
	                        items: [{ original: _image2.default }, { original: _image4.default }, { original: _image6.default }, { original: _image8.default }, { original: _image10.default }, { original: _image12.default }, { original: _image14.default }] })
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'project-blurb' },
	                    'The Art of Storytelling and what it means to grow older in the community.'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Age-friendliness'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Communities'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Storytelling'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Narrative Analysis'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Participative Observation'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Art'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Exhibition'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Creative Workshops'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'highlight' },
	                            'Cooperation Partner:'
	                        ),
	                        ' Council on the Ageing (COTA) Victoria, Arts Access Victoria (AAV), Suzanne Nguyen'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'highlight' },
	                            'Source:'
	                        ),
	                        ' Observations and Narratives'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'highlight' },
	                            'Date:'
	                        ),
	                        ' April 2014'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = AgeFriendlyCommunitiesPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-age-friendly-communities-js-1ba8c072ad86eeaf1973.js